/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Common_Loading1Inputs */

const id_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat...`)
};

const ms_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat...`)
};

const da_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indlæser...`)
};

const de_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lädt...`)
};

const en_us2_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading...`)
};

const es_es2_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando...`)
};

const es_mx2_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando...`)
};

const fil_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naglo-load...`)
};

const fr_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement…`)
};

const it_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento...`)
};

const hu_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betöltés...`)
};

const nl_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laden...`)
};

const no_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laster...`)
};

const pl_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ładowanie...`)
};

const pt_br2_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando...`)
};

const pt_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar...`)
};

const ro_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se încarcă...`)
};

const fi_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladataan...`)
};

const sv_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laddar...`)
};

const vi_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải...`)
};

const tr_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yükleniyor...`)
};

const cs_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načítání...`)
};

const bg_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зареждане...`)
};

const ru_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка...`)
};

const uk_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантаження...`)
};

const ar_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ التحميل...`)
};

const hi_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लोड हो रहा है...`)
};

const th_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังโหลด...`)
};

const ja_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込み中...`)
};

const zh_cn2_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载中...`)
};

const zh_hant1_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`載入中...`)
};

const ko_offerdetail_common_loading1 = /** @type {(inputs: Offerdetail_Common_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로딩 중...`)
};

/**
* | output |
* | --- |
* | "Loading..." |
*
* @param {Offerdetail_Common_Loading1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_common_loading1 = /** @type {((inputs?: Offerdetail_Common_Loading1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Common_Loading1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_common_loading1(inputs)
	if (locale === "ms") return ms_offerdetail_common_loading1(inputs)
	if (locale === "da") return da_offerdetail_common_loading1(inputs)
	if (locale === "de") return de_offerdetail_common_loading1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_common_loading1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_common_loading1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_common_loading1(inputs)
	if (locale === "fil") return fil_offerdetail_common_loading1(inputs)
	if (locale === "fr") return fr_offerdetail_common_loading1(inputs)
	if (locale === "it") return it_offerdetail_common_loading1(inputs)
	if (locale === "hu") return hu_offerdetail_common_loading1(inputs)
	if (locale === "nl") return nl_offerdetail_common_loading1(inputs)
	if (locale === "no") return no_offerdetail_common_loading1(inputs)
	if (locale === "pl") return pl_offerdetail_common_loading1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_common_loading1(inputs)
	if (locale === "pt") return pt_offerdetail_common_loading1(inputs)
	if (locale === "ro") return ro_offerdetail_common_loading1(inputs)
	if (locale === "fi") return fi_offerdetail_common_loading1(inputs)
	if (locale === "sv") return sv_offerdetail_common_loading1(inputs)
	if (locale === "vi") return vi_offerdetail_common_loading1(inputs)
	if (locale === "tr") return tr_offerdetail_common_loading1(inputs)
	if (locale === "cs") return cs_offerdetail_common_loading1(inputs)
	if (locale === "bg") return bg_offerdetail_common_loading1(inputs)
	if (locale === "ru") return ru_offerdetail_common_loading1(inputs)
	if (locale === "uk") return uk_offerdetail_common_loading1(inputs)
	if (locale === "ar") return ar_offerdetail_common_loading1(inputs)
	if (locale === "hi") return hi_offerdetail_common_loading1(inputs)
	if (locale === "th") return th_offerdetail_common_loading1(inputs)
	if (locale === "ja") return ja_offerdetail_common_loading1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_common_loading1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_common_loading1(inputs)
	return ko_offerdetail_common_loading1(inputs)
});
export { offerdetail_common_loading1 as "offerDetail.common.loading" }